import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-platform-services',
  templateUrl: './platform-services.component.html',
  styleUrls: ['./platform-services.component.css']
})
export class PlatformServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
